import { Avatars } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/MultiUser/Avatars";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import compact from "lodash/compact";
import React from "react";

interface IProps {
  layoutElement: ILayoutElement;
}

export const AvatarRenderer: React.FC<IProps> = ({ layoutElement }) => {
  const simpleImageTitles = compact(
    layoutElement.layout_element_data.map((data) => data.simple_image_title)
  );
  const additionalUsers = simpleImageTitles.find(
    (simpleImageTitle) =>
      !simpleImageTitle?.image && !simpleImageTitle?.images.length
  );
  const teamMemberUserData = simpleImageTitles.find(
    (simpleImageTitle) =>
      simpleImageTitle?.image || simpleImageTitle?.images.length
  );

  if (
    layoutElement.type === ILayoutElement.Type.TALL_CATEGORY_TILE &&
    layoutElement.homepage_template_type === "EXPLORE" &&
    teamMemberUserData
  ) {
    return (
      <Avatars
        simpleImageTitle={teamMemberUserData}
        additionalUsers={additionalUsers?.main_text}
      />
    );
  } else {
    return null;
  }
};
